export default [
  {
    path: 'units',
    name: 'admin:inventory:units',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/units/UnitsTable.vue'),
  },
  {
    path: 'suppliers',
    name: 'admin:inventory:suppliers',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/suppliers/SuppliersTable.vue'),
  },
  {
    path: 'suppliers/process/:id?',
    name: 'admin:inventory:suppliers-process',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/suppliers/ProcessSupplierPage.vue'),
  },
  {
    path: 'items',
    name: 'admin:inventory:recipes',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/items/RecipesTable.vue'),
  },
  {
    path: 'ingredients',
    name: 'admin:inventory:ingredients',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/items/IngredientsTable.vue'),
  },
  {
    path: 'report',
    name: 'admin:inventory:report',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/stock/StockMovementsTable.vue'),
  },
  {
    path: 'transactions',
    name: 'admin:inventory:transactions',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/transactions/TransactionsTable.vue'),
  },
  {
    path: 'transactions/:type/:id?',
    name: 'admin:inventory:transactions:type',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/transactions/ProcessTransactionPage.vue'),
  },
  {
    path: 'branches',
    name: 'admin:inventory:branches',
    component: () => import(/* webpackChunkName: "inventory" */ '@/views/admin/inventory/items/BranchInventoryItems.vue'),
  },
]
